const solutionsComp = (gsap) => {
  
  let timer = '';
  const $body = $('body');
  const $main = $('main');
  const $orbOne = $('circle.blueOrb');
  const $orbTwo = $('circle.magentaOrb');
  const $orbThree = $('circle.tealOrb');
  const $solutionsComponent = $('.comp__solution_blocks .solutions-list');
  const $solutionOne = $('.solution-block:nth-child(1)');
  const $solutionTwo = $('.solution-block:nth-child(2)');
  const $solutionThree = $('.solution-block:nth-child(3)');

  if ($solutionsComponent.length) {
  
    $solutionsComponent.mouseenter(function() {
      timer = setTimeout(function () {
        $body.addClass('blackout');
        $main.addClass('hide-overflow');
      }, 200);
    }).mouseleave(function() {
      clearTimeout(timer);
      $body.removeClass('blackout');
      $main.removeClass('hide-overflow');
    });
    
  }
  
  if ($solutionOne.length) {

    $solutionOne.mouseenter(function() {
      $orbOne.addClass('active');
    }).mouseleave(function() {
      $orbOne.removeClass('active');
    });

  }
  
  if ($solutionTwo.length) {

    $solutionTwo.mouseenter(function() {
      $orbTwo.addClass('active');
    }).mouseleave(function() {
      $orbTwo.removeClass('active');
    });

  }
  
  if ($solutionThree.length) {

    $solutionThree.mouseenter(function() {
      $orbThree.addClass('active');
    }).mouseleave(function() {
      $orbThree.removeClass('active');
    });

  }
  
}

export {
  solutionsComp
};
